// Help / about modal — the "?" in the title bar. What BKA is, a few
// usage notes, and links out. Doubles as the "what's new" surface for
// the alpha.

export function HelpModal({ onClose }: { onClose: () => void }) {
  return (
    <div className="help-backdrop" onClick={onClose}>
      <div className="help-card" onClick={(e) => e.stopPropagation()}>
        <div className="help-mark">BKA</div>
        <div className="help-tag">you are the platform</div>

        <p className="help-lede">
          BKA is your own publishing platform. Your writing lives in <em>your</em> GitHub repos;
          your site is served from <em>your</em> Cloudflare account. We host nothing — that's the
          whole point. If you ever want to leave, everything comes with you.
        </p>

        <div className="help-section">
          <div className="help-h">The loop</div>
          <ol className="help-list">
            <li><b>Compose</b> — draft with AI at your elbow; ask for edits, it works in the document.</li>
            <li><b>Media</b> — drop in images, audio, video (sidebar in Compose).</li>
            <li><b>Publish</b> — graduates a draft to your live site in one press.</li>
            <li><b>Settings</b> — pick a theme + accent, edit your bio + About page.</li>
            <li><b>Stats</b> — your post history + opt-in discovery.</li>
          </ol>
        </div>

        <div className="help-section">
          <div className="help-h">Good to know</div>
          <ul className="help-list">
            <li>Drafts save the instant you type and back up to your private repo.</li>
            <li>Your default writing model is <b>Bundle of Babies</b>; switch to Claude anytime.</li>
            <li>After publishing, Cloudflare redeploys your site in ~30–60s.</li>
          </ul>
        </div>

        <div className="help-links">
          <a href="https://github.com/Binary-Blender/bka" target="_blank" rel="noreferrer">source ↗</a>
          <a href="https://binary-blender.com/apps" target="_blank" rel="noreferrer">other apps ↗</a>
        </div>

        <button className="help-close" onClick={onClose}>close</button>
      </div>

      <style>{`
        .help-backdrop { position: fixed; inset: 0; z-index: 3000; background: rgba(40,34,22,0.32); display: flex; align-items: center; justify-content: center; padding: var(--space-4); }
        .help-card { width: min(480px, 100%); max-height: 88vh; overflow: auto; background: var(--paper-raised); border: 1px solid var(--line); border-radius: var(--radius-2); box-shadow: var(--shadow-2); padding: var(--space-6); }
        .help-mark { font-family: var(--font-serif); font-size: 32px; font-weight: 600; color: var(--teal); letter-spacing: 0.04em; }
        .help-tag { font-size: 11px; text-transform: uppercase; letter-spacing: 0.2em; color: var(--ink-soft); margin-bottom: var(--space-4); }
        .help-lede { font-family: var(--font-serif); font-size: 15px; line-height: 1.6; color: var(--ink-soft); margin: 0 0 var(--space-5); }
        .help-lede em { color: var(--ink); font-style: italic; }
        .help-section { margin-bottom: var(--space-4); }
        .help-h { font-family: var(--font-mono); font-size: 10px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--ink-faint); margin-bottom: var(--space-2); }
        .help-list { margin: 0; padding-left: 18px; font-size: 13px; line-height: 1.7; color: var(--ink-soft); }
        .help-list b { color: var(--ink); }
        .help-links { display: flex; gap: var(--space-4); margin: var(--space-4) 0; font-size: 13px; }
        .help-close { font-family: var(--font-sans); font-size: 13px; font-weight: 600; color: var(--teal); background: var(--teal-dim); border: none; border-radius: var(--radius-1); padding: 8px 18px; cursor: pointer; }
      `}</style>
    </div>
  );
}
